import React from 'react';
import { Form } from 'antd';
import CommentCard from '../CommentCard/CommentCard';
import OneFieldFormModal from '../modals/OneFieldFormModal/OneFieldFormModal';
import useChangeModalVisible from '../../../../../hooks/useChangeModalVisible';
import { texts } from '../../../constants/texts';

const ChangeCommentModal = Form.create({ name: 'change_comment' })(
  OneFieldFormModal
);

const CommentCardWithModal = ({
  cardClassName,
  comment,
  loading,
  address,
  onSubmit,
}) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  return (
    <>
      <CommentCard
        className={cardClassName}
        onChangeBtnClick={showModal}
        comment={comment}
        loading={loading}
      />
      <ChangeCommentModal
        visible={visible}
        onCancel={hideModal}
        initialValue={comment}
        subtitle={address}
        title={comment ? texts.editComment : texts.addComment}
        okText={comment ? texts.edit : texts.add}
        cancelText={texts.cancel}
        label={texts.comment}
        inputName="comment"
        onSubmit={onSubmit}
        requiredErrMsg="Напишите комментарий"
        fieldType="area"
      />
    </>
  );
};

export default CommentCardWithModal;
